"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthorizer = void 0;
const types_1 = require("../types");
function createAuthorizer(permissionStore) {
    const accessRights = new Map();
    return {
        registerAccessRights(...accessRightConfigs) {
            accessRightConfigs.forEach(right => accessRights.set(right.name, right));
        },
        authorize(accessRightName) {
            const accessRightInfo = accessRights.get(accessRightName);
            return accessRightInfo !== undefined && accessRightInfo.permissions[accessRightInfo.mode === types_1.AccessRightMode.all ? 'every' : 'some'](permissionKey => permissionStore.has(permissionKey));
        }
    };
}
exports.createAuthorizer = createAuthorizer;
//# sourceMappingURL=authorizer.js.map